import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBox } from '../context/BoxContext';

const DefaultRedirect: React.FC = () => {
  const { user } = useAuth();
  const { selectedBoxId } = useBox();

  if (selectedBoxId) {
    return <Navigate to="/weekly-view" replace />;
  }

  if (user?.role === 'ADMIN') {
    return <Navigate to="/users" replace />;
  }

  return <Navigate to="/weekly-view" replace />;
};

export default DefaultRedirect;
